export default __webpack_public_path__ + "../staticImages/silvester_rabatt-260.png";